import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import AddIcon from '@mui/icons-material/Add';
import MenuItem from '@mui/material/MenuItem';
import CustomAccordion from '../../../molecules/Accordion.js';

import {
  FlexGridColumnGroup,
} from '@grapecity/wijmo.react.grid';
import {
  FormControl,
  FormGroup,
} from '@mui/material';
import {
  getCodeFromGeneralPurposeMap,
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect, renderCheckbox, renderSelectMultiLine} from '../../../atoms/CustomPart.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import * as validateRule from '../../../validateRule.js';
import {CellType} from '@grapecity/wijmo.grid';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.CUSTOMER_INDIVIDUAL_MANAGE_LIST.name, href: ''},
];

const styles = (theme) => ({
  button: {
    margin: '15px 10px 5px 10px',
  },
  wave: {
    // fontSize: '1.2em',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
});

// 可否判定申込で使用する申込ステータスコード
// 作成中,可否判定受付中,強度計算中,可否判定中,可否判定済,本申込中,完結（期限切れ）,完結（取止め）,完結（申込済）
// const proprietyOrderStatus = ['00', '01', '02', '03', '04', '05', '91', '92', '93'];

/**
 * お客さま個別管理
 * 画面ID:SCA1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
      SearchFlg: false,
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    // let _warningMessages = [];
    // let message5 = {
    //   id: 'SCA100201E',
    //   values: ['2,200', '2,000'],
    // };
    // _warningMessages.push(message5);
    this.setState({
      // warningMessages: _warningMessages,
      SearchFlg: true,
    });
    const data =[
      {waitUpdate: '51602025031401', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/14', sinnseiStatus: '作成中', userName: '田中　さくら', hiKetuFlag: true},
      {waitUpdate: '51602025031402', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/14', sinnseiStatus: '作成中', userName: '田中　さくら', hiKetuFlag: false},
      {waitUpdate: '51602025031501', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/15', sinnseiStatus: '報告中', userName: '田中　さくら', hiKetuFlag: false},
      {waitUpdate: '51602025031502', zigyoujo: '広島北NWC（旧廿日市NWC）', keiyakuNo: '2025/3/15', sinnseiStatus: '完了', userName: '田中　さくら', hiKetuFlag: false},
      {waitUpdate: '51602025031503', zigyoujo: '広島北NWC（旧廿日市NWC）', keiyakuNo: '2025/3/15', sinnseiStatus: '完了', userName: '田中　さくら', hiKetuFlag: false},
      {waitUpdate: '51602025031701', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/17', sinnseiStatus: '確認中', userName: '田中　さくら', hiKetuFlag: true},
      {waitUpdate: '51602025031801', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/18', sinnseiStatus: '承認中', userName: '田中　さくら', hiKetuFlag: false},
      {waitUpdate: '51602025031802', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/18', sinnseiStatus: '承認中', userName: '田中　さくら', hiKetuFlag: false},
      {waitUpdate: '51602025032001', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/20', sinnseiStatus: '完了', userName: '田中　さくら', hiKetuFlag: false},
      {waitUpdate: '51602025032101', zigyoujo: '広島北NWC', keiyakuNo: '2025/3/21', sinnseiStatus: '取止済', userName: '田中　さくら', hiKetuFlag: false},
    ];

    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    this.setState({
      SearchFlg: false,
    });
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    // try {
    //   const result = await this._searchOrder();
    //   if (!result) {
    //     return;
    //   }
    //   // 検索結果が0件の場合、エラーダイアログ表示
    //   if (!this.props.hasOwnProperty('orderList') ||
    //     !this.props.orderList ||
    //     this.props.orderList.length <= 0 ) {
    //     this.props.doShowMessage({
    //       message: 'CE0016',
    //     });
    //   }
    // } catch (error) {
    //   this.props.doShowMessage({
    //     message: 'TKSCS00001S',
    //     action: () => {
    //       this.props.history.push('/login');
    //     },
    //   });
    // }
    // this.gridRef = {}
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 新規作成ボタン押下時
   */
  doTenNext = async () => {
    try {
      // const {generalPurposeMap} = this.props;
      // this.props.doSetOrderId(null);
      // this.props.doSetOrderModifiedCondition(null, null);
      // this.props.doClearOrderInfo(); // 前回データをクリア
      // this.props.doSetStbType(getCodeFromGeneralPurposeMap(generalPurposeMap, 'StbType2', 1));
      // this.props.history.push({pathname: '/TenProprietyBasicInfo'});
      let params = {
        // waitUpdate,
        mod: 'I',
      };
      // お客さま個別管理画面に遷移
      setSessionObject(GMN.CUSTOMER_INDIVIDUAL_MANAGE_INFO.id, params);
      this.props.navigate(GMN_PATH.CUSTOMER_INDIVIDUAL_MANAGE_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 編集ボタン押下時
   */
  doEdit = () => {
    try {
      if (!this.gridRef ||
        !this.gridRef.current) {
        return;
      }

      const count = this.gridRef.current.selectedItemCount();
      if (count != 1) {
        this.props.doShowMessage({
          message: {
            id: 'CE0022',
          },
        });
        return;
      }

      const stbTypeSen = getCodeFromGeneralPurposeMap(this.props.generalPurposeMap, 'StbType1', 1);
      const stbTypeTen = getCodeFromGeneralPurposeMap(this.props.generalPurposeMap, 'StbType2', 1);
      const items = this.gridRef.current.selectedItem();
      this.props.doSetOrderId(items[0].dataItem.Id);
      this.props.doSetStbType(items[0].dataItem.StbType__c);
      this.props.doSetOrderModifiedCondition(
          items[0].dataItem.Id, items[0].dataItem.LastModifiedDate);
      if (items[0].dataItem.StbType__c == stbTypeSen) {
        this.props.history.push({pathname: '/SenProprietyBasicInfo'});
      }
      if (items[0].dataItem.StbType__c == stbTypeTen) {
        this.props.history.push({pathname: '/TenProprietyBasicInfo'});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };
  /**
   * 削除ボタン押下時
   */
  doDelete = () => {
    let _warningMessages = null;
    try {
      if (!this.gridRef ||
      !this.gridRef.current) {
        return;
      }
      // 未選択チェック
      const count = this.gridRef.current.selectedItemCount();
      if (count === 0) {
        this.props.doShowMessage({
          message: {
            id: 'BFY000023E',
            values: ['削除'],
          },
        });
        return;
      }
      const items = this.gridRef.current.selectedItem();
      let cv = this.gridRef.current.grid.collectionView;
      cv.beginUpdate();
      // 削除
      for (let rowIndex = count - 1; rowIndex >= 0; rowIndex --) {
        let removeIndex = items[rowIndex].index;
        cv.removeAt(removeIndex);
      }
      cv.endUpdate();
    } catch (error) {
      // sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', height: 'auto', width: 'auto', marginTop: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
    };

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        <FlexGridColumnGroup
          binding="waitUpdate"
          header="申請番号"
          cellTemplate={CellMaker.makeLink({
            click: (e, ctx) => {
              this.doEditLink(ctx.item.waitUpdate, ctx.item.sinnseiStatus,
                  ctx.item.hiKetuFlag);
            },
          })}
          dataType="String"
          width={150}/>
        <FlexGridColumnGroup binding="zigyoujo" header="NW事業所" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="userName" header="作成者" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="keiyakuNo" header="作成日" dataType="String" width={150}/>
        <FlexGridColumnGroup binding="sinnseiStatus" header="ステータス" dataType="String" width={150}/>
      </CustomFlexGrid>
    );
  }

  /**
         * 項目フォーマット処理
         *
         * @param {object} s sender
         * @param {string} e event
         */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
      // ReadOnlyのセルか？
      // if (e.cell.ariaReadOnly) {
      //   e.cell.style.backgroundColor = '#e6e6fa';
      // }
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      if (col && ((col.binding === 'sinnseiStatus' &&
              data.hiKetuFlag === true) )) {
        // e.cell.style.backgroundColor = '#fff0f5';
        e.cell.style.backgroundColor = '#ff0000';
      }
    }
  };

  /**
   * 一覧リンククリック時
   * @param {*} waitUpdate 申請番号
   * @param {*} sinnseiStatus ステータス
   * @param {*} hiKetuFlag 否決フラグ
   */
  doEditLink = async (waitUpdate, sinnseiStatus, hiKetuFlag) => {
    try {
      let params = {
        waitUpdate,
        mod: 'U',
        hiKetuFlag: hiKetuFlag,
      };
      // if (sinnseiStatus =='作成中' || sinnseiStatus =='取止済') {
      //   params = {
      //     waitUpdate,
      //     mod: 'C',
      //   };
      // } else if (sinnseiStatus =='承認中') {
      //   params = {
      //     waitUpdate,
      //     mod: 'U',
      //   };
      // } else if (sinnseiStatus =='確認中') {
      //   params = {
      //     waitUpdate,
      //     mod: 'M',
      //   };
      // } else {
      //   params = {
      //     waitUpdate,
      //     mod: 'U',
      //   };
      // }

      // お客さま個別登録画面に遷移
      setSessionObject(GMN.CUSTOMER_INDIVIDUAL_MANAGE_INFO.id, params);
      this.props.navigate(GMN_PATH.CUSTOMER_INDIVIDUAL_MANAGE_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };
  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="sinseiId" item xs={12} sm={2}>
            <Field
              id="sinseiId"
              name="sinseiId"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="申請番号"
              fullWidth
              type="text"
              required={false}
            // validate={[
            //   validateRule.number,
            //   validateRule.maxLength(22),
            // ]}
            />
          </Grid>
          <Grid key="zigyoujoCon" item xs={12} sm={2}>
            <Field
              id="zigyoujoCon"
              name="zigyoujoCon"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
              {/* <MenuItem value={6120}>{'山口NWC'}</MenuItem> */}
            </Field>
          </Grid>
          <Grid key="createDate" item xs={12} sm={4}>
            <div style={{position: 'relative'}}>
              <Field
                id="createDateFrom"
                name="createDateFrom"
                // accessibilitylabel={option.id + 'From'}
                label="作成日"
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
              // validate={[
              //   validateRule.date,
              //   validateRule.correctFromDate(values ? values[option.id + 'To'] : null),
              // ]}
              />
              <span className="wave">～</span>
              <Field
                id="createDateTo"
                name="createDateTo"
                // accessibilitylabel={option.id + 'To'}
                label={<React.Fragment />}
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
              // validate={[
              //   validateRule.date,
              //   validateRule.correctDate(values ? values[option.id + 'From'] : null),
              // ]}
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="states" item xs={12} sm={2}>
            <Field
              id="states"
              name=""
              // variant="standard"
              component={renderSelectMultiLine}
              className="fields"
              label="ステータス"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={10}>{'作成中'}</MenuItem>
              <MenuItem value={40}>{'報告中'}</MenuItem>
              <MenuItem value={50}>{'確認中'}</MenuItem>
              <MenuItem value={60}>{'承認中'}</MenuItem>
              <MenuItem value={90}>{'完了'}</MenuItem>
              <MenuItem value={'00'}>{'取止済'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="smdsZtiKbn" item xs={12} sm={2}>
            <Field
              id="smdsZtiKbn"
              name="smdsZtiKbn"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="否決"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'否決あり'}</MenuItem>
              <MenuItem value={2}>{'否決なし'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="rerportWait" item xs={12} sm={3}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="rerportWait"
                  name="rerportWait"
                  component={renderCheckbox}
                  label="作成者（自分のみ）"
                  onChange={this._handleChangeCheckbox}
                  // checked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
        {/* <div style={{marginBottom: '15px'}} /> */}
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {/* <Grid key="key1001Back" item>
          <BackButton props={this.props}/>
        </Grid> */}
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={handleSubmit(this.doTenNext)}
            // disabled={this.state.buttonDisabled2}
            variant="contained"
            startIcon={<AddIcon />}
            // size="large"
          >
            <span>新規作成</span>
          </PositiveButton>
        </Grid>
        {/* <Grid key="key1001CreateTen3" item>
          <DangerButton
            id="btn1001CreateTen3"
            // onClick={handleSubmit(this.doTenNext)}
            variant="contained"
            startIcon={<DeleteIcon />}
            disabled={this.state.buttonDisabled}
            onClick={this.doDelete}
            // size="large"
          >
            <span>削除</span>
          </DangerButton>
        </Grid> */}

      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
